import { create } from "zustand";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";

export interface ActiveAppState {
  appId: string | null;
  title: string;
  subtitle: string;
  icon: IconDefinition | null;
  iconColor: string;
  setActiveApp: (
    appId: string,
    title: string,
    subtitle: string,
    icon?: IconDefinition,
    iconColor?: string
  ) => void;
  clearActiveApp: () => void;
}

export const useActiveAppStore = create<ActiveAppState>((set) => ({
  appId: null,
  title: "",
  subtitle: "",
  icon: null,
  iconColor: "",
  setActiveApp: (appId, title, subtitle, icon, iconColor) =>
    set({ appId, title, subtitle, icon: icon || null, iconColor: iconColor || "" }),
  clearActiveApp: () =>
    set({ appId: null, title: "", subtitle: "", icon: null, iconColor: "" }),
}));
